import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FaFilePdf, FaFileWord } from "react-icons/fa";
import { GetVendorDetailSlice } from "../../../../redux/features/VendorManagementSlice";

const VendorDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const { VendorDetail, loading } = useSelector((state) => state.VendorManagement);

  useEffect(() => {
    dispatch(GetVendorDetailSlice(id));
  }, [id]);

  if (loading || !VendorDetail) {
    return (
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            <h2>Loading vendor...</h2>
          </div>
        </div>
      </div>
    );
  }

  const vendor = VendorDetail;

  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="TitleBox">
          <h2>{vendor?.businessName}</h2>
          <div>
            <Link to={`/VendorManagement/Vendors/EditVendor/${vendor?._id}`} className="Button" style={{ marginRight: "10px" }}>
              Edit Vendor
            </Link>
            <a href="javascript:void(0);" className="Button Cancel" onClick={() => navigate(-1)}>
              Back
            </a>
          </div>
        </div>

        <div className="Small-Wrapper">
          <div className="TitleBox">
            <h2>Basic Information</h2>
          </div>
          <div className="ItineraryArea">
            <div className="row">
              <div className="col-sm-4"><strong>Vendor Id:</strong> {vendor?.vendorId}</div>
              <div className="col-sm-4"><strong>Owner Name:</strong> {vendor?.ownerName}</div>
              <div className="col-sm-4"><strong>Contact Person:</strong> {vendor?.contactPersonName}</div>
              <div className="col-sm-4"><strong>Mobile 1:</strong> {vendor?.mobile1}</div>
              <div className="col-sm-4"><strong>Mobile 2:</strong> {vendor?.mobile2 || "-"}</div>
              <div className="col-sm-4">
                <strong>City:</strong> {vendor?.city?.cityName}
                {vendor?.city?.state ? `, ${vendor?.city?.state}` : ""}
              </div>
              <div className="col-sm-4"><strong>Pincode:</strong> {vendor?.pincode || "-"}</div>
              <div className="col-sm-8"><strong>Address:</strong> {vendor?.address || "-"}</div>
              <div className="col-sm-12"><strong>Description:</strong> {vendor?.description || "-"}</div>
              <div className="col-sm-4">
                <strong>Status:</strong>{" "}
                <span className={vendor?.isActive ? "Green" : "Red"}>
                  {vendor?.isActive ? "Active" : "Inactive"}
                </span>
              </div>
              <div className="col-sm-4">
                <strong>Created On:</strong> {vendor?.createdAt?.substring(0, 10)}
              </div>
            </div>
          </div>
        </div>

        {(vendor?.categories || []).map((cat, catIndex) => (
          <div className="Small-Wrapper" key={cat?.categoryId?._id || catIndex}>
            <div className="TitleBox">
              <h2>{cat?.categoryId?.categoryName}</h2>
            </div>
            {(cat?.packages || []).length === 0 ? (
              <p>No packages added under this category.</p>
            ) : (
              (cat?.packages || []).map((pkg, pkgIndex) => (
                <div
                  key={pkgIndex}
                  style={{
                    border: "1px solid lightgray",
                    borderRadius: "10px",
                    padding: "15px",
                    marginBottom: "15px",
                  }}
                >
                  <h4 style={{ marginBottom: "5px" }}>{pkg?.packageName}</h4>
                  <p style={{ fontWeight: 600 }}>
                    ₹{pkg?.lowestPrice} - ₹{pkg?.approximatePrice}
                  </p>
                  {pkg?.description && <p>{pkg?.description}</p>}
                  {pkg?.workIncludes && (
                    <p>
                      <strong>Work Includes:</strong> {pkg?.workIncludes}
                    </p>
                  )}

                  {Array.isArray(pkg?.images) && pkg.images.length > 0 && (
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "10px" }}>
                      {pkg.images.map((url, imgIndex) => (
                        <img
                          key={imgIndex}
                          src={url}
                          alt=""
                          style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "6px" }}
                        />
                      ))}
                    </div>
                  )}

                  {Array.isArray(pkg?.documents) && pkg.documents.length > 0 && (
                    <div style={{ display: "flex", flexDirection: "column", gap: "6px", marginTop: "10px" }}>
                      {pkg.documents.map((doc, docIndex) => (
                        <div key={docIndex} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          {doc.fileType === "application/pdf" ? (
                            <FaFilePdf color="red" />
                          ) : (
                            <FaFileWord color="blue" />
                          )}
                          <a href={doc.url} target="_blank" rel="noreferrer">
                            {doc.name}
                          </a>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default VendorDetails;
